import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  isMobile,
  isTablet,
  isBrowser,
  isSmartTV,
  deviceType,
  osName
} from 'react-device-detect';
import {
  CartItemAddToWishList,
  ismailsubscribed,
  subscribeUser,
  getAllCountryNames,
  checkPincodeAvailabilityAPI,
  add_to_cart,
  updateCartLatestPrice,
} from "../utilities/api";
import { toast, ToastContainer } from "react-toastify";
import config from "../utilities/config";
import constants from "../utilities/constants";
import {
  formatCurrency,
  getValue,
  formatCurrencywithamount,
} from "../utilities/helper";
import {
  getCartpagedata,
  getCartpagedata_count,
  youMayLikeData,
  removeCartItem,
  getCartpagedata_count_without_login,
  Update_Cart_Latest_Price,
  Add_To_Cart,
  removeCartItemWithoutlogin,
  apply_voucher,
} from "../redux/action/cartAction";
import { Link, useNavigate } from "react-router-dom";
import { getAuthModalType, loginModalAction } from "../redux/action/authAction";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import "../styles/styles.css";
import { Toast } from "../../src/components/Atoms/Toast";

// import required modules
import { Grid, Pagination, Autoplay } from "swiper/modules";
import { getPersionalData } from "../redux/action/myAccountAction";
import { subscribeUserWithMail } from "../redux/action/homeAction";

// import ring from '../product_img/ring-sr0014.jpg';
// import chain1 from '../product_img/chain1.jpg';
// import chain2 from '../product_img/chain2.jpg';
// import chain3 from '../product_img/chain3.jpg';
// import chain4 from '../product_img/chain4.jpg';

function Cart() {
  const navigate = useNavigate(); // React Router hook for navigation
  const dispatch = useDispatch();
  const [subscribed_user, setsubscribed_user] = useState(0);
  const { selectedcountrySuccess, dailyMetalPriceSuccess } = useSelector(
    (state) => state.homeReducer
  );
  const descriptionShow = (description) => {
    const maxLength = isMobile || isTablet ? 22 : 40;
    return description?.length > maxLength ? description?.slice(0, maxLength - 1) + ".." : description;
  };
  const descriptionShowYouMayLike = (description) => {
    const maxLength = isMobile || isTablet ? 15 : 30;
    return description?.length > maxLength ? description?.slice(0, maxLength - 1) + ".." : description;
  };
  //apply voucher
  const {
    voucherResponesLoading,
    voucherSuccessmessage, voucherDescription,
    voucherPriceResponse,
    voucherResponseError,
  } = useSelector((state) => state.voucherreducer);
  config.logGeneral && console.log(
    voucherSuccessmessage,
    "voucherSuccessmessage",
    voucherPriceResponse,
    "voucherPriceResponse"
  );
  const [countrynames, setcountrynames] = useState([]);
  const [pincode, setPincode] = useState("");
  const [country, setcountry] = useState("India");
  const [cartApiCalled, setCartApiCalled] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const [activeIndex, setActiveIndex] = useState(0);

  //to get the user info from authReducer
  const {
    userProfile_id,
    userProfile_email,
    loginModalType,
    authModalType,
    cartID, isemailsubscribed
  } = useSelector((state) => state.authReducer);
  // addtocartreducer
  const { add_to_cartResponseSuccess } = useSelector(
    (state) => state.addtocartreducer
  );
  const {update_cart_latest_priceResponseSuccess}=useSelector((state) => state.updateCartLatestPricereducer)
  //to get the cart count...
  const {
    cart_items_numberResponesLoading,
    cart_items_numberResponseSuccess,
    cart_items_numberResponseSuccess_info,
    cart_items_numberResponseError,
  } = useSelector((state) => state.cartNumberReducer);
  config.logGeneral && console.log(cart_items_numberResponseSuccess_info,"cart_items_numberResponseSuccess_infoooooo",cart_items_numberResponseSuccess,"cart_items_numberResponseSuccess")
  //to get the you may like...
  
  const { youMayLike_responseSuccess } = useSelector(
    (state) => state.youMayLikeReducer
  );
  const cartId = cart_items_numberResponseSuccess
    ? cart_items_numberResponseSuccess?.nodes[0]?.id
    : "";
  let cartdetailsinLocalstorage = localStorage.getItem("cartDetails");
  let cartDetails = JSON.parse(cartdetailsinLocalstorage);
  const cartItemsProductInfo =
    cart_items_numberResponseSuccess?.nodes[0]
      ?.shoppingCartItemsByShoppingCartId?.nodes || [];
  const discountprice_ordersummary = cart_items_numberResponseSuccess_info?.reduce(
    (total, item) => {
      return total + (item?.transSkuListByProductSku?.discountPrice || 0);
    },
    0 // <-- initial value for total
  );
  const markupprice_ordersummary = cart_items_numberResponseSuccess_info?.reduce(
    (total, item) => {
      return total + (item?.transSkuListByProductSku?.markupPrice || 0);
    },
    0 // <-- initial value for total
  );
  config.logGeneral && console.log(discountprice_ordersummary,"discountprice_ordersummaryoooo")


  const actualPrice = cart_items_numberResponseSuccess?.nodes[0]?.grossAmount;
  const discountedPrice = cart_items_numberResponseSuccess?.nodes[0]?.discountedPrice;
  const actualPrice_without_login = cartDetails?.products?.reduce(
    (total, item) => {
      return total + (item?.price || 0);
    },
    0
  );
  const netPrice_without_login = cartDetails?.products?.reduce(
    (total, item) => {
      return total + (item?.discountprice || 0);
    },
    0
  );

  const youMayLike =
    youMayLike_responseSuccess?.data?.data?.youMayalsolike1?.nodes || [];
  const getImage = (image, size = "300X300") => {
    let productId = image?.split("/");
    return `${constants.image_url}${productId?.[0]}/${productId?.[1]}/${size}/${productId?.[2]}`;
  };

  const mailSubscription = async () => {
    let respomailsubscription = await ismailsubscribed(userProfile_email);

    if (respomailsubscription?.length == 0) {
      setsubscribed_user(1);
    }
  };

  // Function to handle proceed checkout
  const handleProceedCheckout = () => {
    // Dispatch action to proceed checkout
    if (userProfile_id !== null) {
      // navigation(constants.ADDITIONAL_PATH+'/cart')
      window.location.href = constants.ADDITIONAL_PATH + "/checkout";
    } else {
      // dispatch(loginModalAction({ isOpenModal: true, modalType: "cart" }));
      dispatch(getAuthModalType(constants.Login));
    }
  };

  // useEffect(() => {
  //   config.logGeneral && console.log("userProfile_id changed!!", userProfile_id);
  //   if (userProfile_id) {
  //     dispatch(getCartpagedata_count(userProfile_id));
  //     mailSubscription();
  //   }

  //   if (!userProfile_id) {
  //     dispatch(getCartpagedata_count_without_login());
  //   }

  //   dispatch(youMayLikeData()); // Fetch "You May Like" data
  //   //calling api to check whether user has already subscribed or not

  //   // if (loginModalType === "cart" && userProfile_id) {
  //   //   addtocartapi(userProfile_id);
  //   // }
  //   if (authModalType === constants.Login && userProfile_id) {
  //     alert("addtocartapicalledincartpage")
  //     addtocartapi(userProfile_id);
  //   }
  // }, [userProfile_id, userProfile_email, loginModalType]);

  useEffect(() => {
    config.logGeneral && console.log("userProfile_id changed!!", userProfile_id);
    if (userProfile_id) {
      dispatch(getCartpagedata_count(userProfile_id));
      mailSubscription();
    }

    // if (!userProfile_id) {
    //   dispatch(getCartpagedata_count_without_login());
    // }

    // dispatch(youMayLikeData()); // Fetch "You May Like" data
  }, [userProfile_id, loginModalType]);
  useEffect(() => {
    dispatch(getCartpagedata_count(userProfile_id));
  }, [voucherSuccessmessage,dispatch]);
  // useEffect(() => {
  //   cart_items_numberResponseSuccess?.nodes[0]?.voucherCode !== "" ?? setIsOpen(true);
  //   cart_items_numberResponseSuccess?.nodes[0]?.voucherCode !== "" ?? setPromoCode(cart_items_numberResponseSuccess?.nodes[0]?.voucherCode)
  // },[cart_items_numberResponseSuccess])
  useEffect(() => {
    const storedCartDetails = JSON.parse(
      localStorage.getItem("cartDetails") || "{}"
    );

    if (userProfile_id && storedCartDetails?.products?.length > 0) {
      // if (cartID) {
      //   config.logGeneral && console.log("kkkkk 01");
      //   dispatch(Update_Cart_Latest_Price(userProfile_id));
      // }
      config.logGeneral && console.log("kkkkkkkkk nw cartid:", cartID);
      dispatch(Add_To_Cart(userProfile_id, storedCartDetails.products, cartID));
      // setTimeout(() => dispatch(Update_Cart_Latest_Price(userProfile_id)),300);
      config.logGeneral && console.log("kkkk nw cartid:", cartID);
      localStorage.removeItem("cartDetails");
      // dispatch(Update_Cart_Latest_Price(userProfile_id))
    }
  }, [userProfile_id, dispatch, cartID]);
  const discount_display_price = (discountValue) => {
    if (discountValue && discountValue > 0 && discountValue !== '0') {
      return `(${discountValue}% - OFF)`;
    }
    else {
      return '';
    }

  }
  const handleApplyClick = () => {
    if (!promoCode.trim()) {
      // Show toast message if promo code is not entered
      Toast("Please enter the Promo Code!", "error");
      return;
    }

    // Prepare form data for the apply_voucher action

    // Dispatch the apply_voucher action
    if (userProfile_id) {
      dispatch(apply_voucher(userProfile_id, cartID, promoCode));
      
    } else {
      dispatch(apply_voucher(userProfile_id, cartID, promoCode));
    }
  };

  // Function to handle item removal from the cart
  const handleRemoveItem = (productSku) => {
    // Dispatch action to remove item from cart
    // alert(userProfile_id)
    

    config.logGeneral && console.log(
      cartId,
      "cartId in cart page",
      productSku,
      "productSku in cart page"
    );
    if (userProfile_id) {
      dispatch(
        removeCartItem(
          cartId,
          productSku,
          userProfile_id,
          cart_items_numberResponseSuccess_info
        )
      );
      // setTimeout(() => {dispatch(Update_Cart_Latest_Price(userProfile_id))},200)
      // Toast("Successfully Product removed from cart!", "success");
      // dispatch(updateCartLatestPrice())
      // dispatch(getCartpagedata_count(userProfile_id));
      dispatch(getPersionalData(userProfile_id));
    } else {
      // dispatch(removeCartItemWithoutlogin(productSku));
      if (cartDetails?.products?.length > 0) {
        cartDetails.products = cartDetails.products.filter(
          (product) => product.sku_id !== productSku
        );
        localStorage.setItem("cartDetails", JSON.stringify(cartDetails));
        Toast("Successfully Product removed from cart!", "success");
      } else {
        Toast("Failed to remove the product from cart!", "error");
      }
    }
  };
  //to add in cart table after login..
  const addtocartapi = async (userProfile_id) => {
    try {
      if (!userProfile_id) {
        Toast("No userProfile_id found!", "error");
        return;
      }
      let result = await add_to_cart(userProfile_id);
    } catch (err) {
      Toast("addtocartapi error..!", "error");
    }
  };

  const checkAvailability = async () => {
    if (!pincode) {
      Toast("Please enter a Zipcode", "error");
      return;
    }
    try {
      const message = await checkPincodeAvailabilityAPI(pincode, country);
      Toast(message, "success");
    } catch (error) {
      Toast(error, "error");
    }
  };
  // Handle the subscription logic when the button is clicked
  const handleSubscribeClick = () => {
    dispatch(subscribeUserWithMail(userProfile_email));
    setsubscribed_user(0);
    // subscribeUser(userProfile_email)
    //   .then((successMessage) => {
    //     Toast(successMessage, "success");
    //     setsubscribed_user(0);
    //   })
    //   .catch((errorMessage) => {
    //     Toast(errorMessage, "error");
    //   });
  };

  // Function to handle Add to Wishlist
  const handleAddToWishlist = (productSku, productId) => {
    CartItemAddToWishList(userProfile_id, productSku, productId)
      .then(() => {
        Toast("Successfully Product Added to wishlsit!", "success");
        return handleRemoveItem(productSku); // return the promise

      })
      .catch((error) => {
        Toast("Error adding item to wishlist", "error");
        config.logGeneral &&
          console.error("Error adding item to wishlist:", error);
      });
  };


  // For Apply Coupon
  const [isOpen, setIsOpen] = useState(false);
  config.logGeneral && console.log(
    cartItemsProductInfo?.length,
    "cartItemsProductInfo?.length",
    cartDetails?.products?.length,
    "cartDetails?.products?.length"
  );

  return (userProfile_id && cartItemsProductInfo?.length > 0) ||
    cartDetails?.products?.length > 0 ? (
    <>
      <div className="bg-white">
        <div className="container mx-auto px-4 2xl:mb-16">
          <div className="grid grid-cols-12 gap-6 mt-5">
            <div className="col-span-12 lg:col-span-8">
              {/* for shipping Availability check... */}
              {/* <div className="lg:flex justify-between items-center gap-4 mb-5 hidden">
                <div className="flex items-center justify-between relative">
                  <p className="mr-5 text-customBlue font-bold text-base">
                    Check Delivery Info
                  </p>
                  <select
                    className="bg-white border-gray-300 text-sm appearance-none px-4 py-3 border shadow-sm focus:outline-none focus:ring-2 focus:ring-customGreen focus:border-customGreen pr-10"
                    onChange={(e) => setcountry(e.target.value)}
                  >
                    <option value="India" selected>
                      IND
                    </option>
                    <option value="United States">USA</option>
                  </select>
                  <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                    <img
                      src={
                        constants.DEFAULT_IMAGE +
                        "/product_care_accortian_down.png"
                      }
                      className="w-4"
                    />
                  </div>
                </div> 
                <div className="flex-1">
                  <input
                    type="text"
                    placeholder="Zipcode"
                    className="border border-gray-300 p-3 w-full mt-3 md:mt-0 text-sm placeholder-[#222222] font-normal"
                    onChange={(e) => setPincode(e.target.value)}
                  />
                </div>
                <div className="flex items-center space-x-4">
                  <button
                    className="border  tracking-wider bg-customGreen text-white px-5 py-3 rounded-none hover:bg-white mt-3 md:mt-0 hover:text-gray-600 hover:border hover:border-customLightGreen duration-500 text-sm"
                    onClick={checkAvailability}
                  >
                    Check Availability
                  </button>
                </div>
              </div>*/}

              {/* Mobile for shipping Availability check... */}
              {/* <div className="md:flex justify-between items-center gap-4 mb-5 lg:hidden">
                <p className="mr-5 text-customBlue font-bold  text-base mb-2">
                  Check Delivery Info
                </p>
                <div className="flex items-center justify-between gap-3">
                  <div className="relative">
                    <select
                      className="bg-white border-gray-300 text-sm  appearance-none px-4 py-3 border shadow-sm focus:outline-none focus:ring-2 focus:ring-customGreen focus:border-customGreen pr-10 rounded-[4px]"
                      onChange={(e) => setcountry(e.target.value)}
                    >
                      <option value="India" selected>
                        IND
                      </option>
                      <option value="United States">USA</option>
                    </select>
                    <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                      <img
                        src={
                          constants.DEFAULT_IMAGE +
                          "/product_care_accortian_down.png"
                        }
                        className="w-4"
                      />
                    </div>
                  </div>
                  <div className="flex-1">
                    <input
                      type="text"
                      placeholder="Zipcode"
                      className="border border-gray-300 p-3 w-full md:mt-0 text-sm placeholder-[#222222]  font-normal rounded-[4px]"
                      onChange={(e) => setPincode(e.target.value)}
                    />
                  </div>
                  <div className="flex items-center space-x-4">
                    <button
                      className="border  tracking-wider bg-customGreen text-white px-5 py-[12.5px] rounded-[4px] hover:bg-white md:mt-0 hover:text-gray-600 hover:border hover:border-customLightGreen duration-500 text-sm"
                      onClick={checkAvailability}
                    >
                      Check
                    </button>
                  </div>
                </div>
              </div> */}

              {/* for newsletter subscription */}
              {subscribed_user == 1 && userProfile_email && !isemailsubscribed && (
                <div className="flex justify-between items-center py-0 flex-1 mt-5 mb-5">
                  <div className="bg-white rounded-full drop-shadow-lg w-14 h-12 lg:w-16 lg:h-16 flex justify-center items-center relative z-[1]">
                    {/* <img
                      src={constants.DEFAULT_IMAGE + "/subscribe.svg"}
                      alt="Subscribe"
                      className="bg-white"
                    /> */}
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_2855_12228)">
                        <path
                          d="M28 10.1011V7.00006C28 6.44781 27.5522 6.00006 27 6.00006H22.414L16.707 0.293063C16.3162 -0.0976875 15.6835 -0.0976875 15.293 0.293063L9.586 6.00006H5C4.44775 6.00006 4 6.44781 4 7.00006V10.1011C1.72075 10.5658 0 12.5856 0 15.0001V27.0001C0 29.7568 2.24325 32.0001 5 32.0001H27C29.7568 32.0001 32 29.7568 32 27.0001V15.0001C32 12.5856 30.2792 10.5658 28 10.1011ZM16 2.41406L19.586 6.00006H12.414L16 2.41406ZM6 8.00006H26V14.5861L16 24.5861L6 14.5861V8.00006ZM30 27.0001C30 28.6543 28.6542 30.0001 27 30.0001H5C3.34575 30.0001 2 28.6543 2 27.0001V15.0001C2 13.6981 2.8385 12.5986 4 12.1843V15.0001C4 15.2653 4.1055 15.5196 4.293 15.7071L9.586 21.0001L4.293 26.2931C3.90225 26.6838 3.90225 27.3166 4.293 27.7071C4.48825 27.9023 4.74425 28.0001 5 28.0001C5.25575 28.0001 5.51175 27.9023 5.707 27.7071L11 22.4141L15.293 26.7071C15.4882 26.9023 15.7443 27.0001 16 27.0001C16.2558 27.0001 16.5118 26.9023 16.707 26.7071L21 22.4141L26.293 27.7071C26.4882 27.9023 26.7442 28.0001 27 28.0001C27.2558 28.0001 27.5118 27.9023 27.707 27.7071C28.0978 27.3163 28.0978 26.6836 27.707 26.2931L22.414 21.0001L27.707 15.7071C27.8945 15.5196 28 15.2653 28 15.0001V12.1843C29.1615 12.5983 30 13.6981 30 15.0001V27.0001ZM10.5 12.0001C10.5 11.4478 10.9478 11.0001 11.5 11.0001H20.5C21.0522 11.0001 21.5 11.4478 21.5 12.0001C21.5 12.5523 21.0522 13.0001 20.5 13.0001H11.5C10.9478 13.0001 10.5 12.5523 10.5 12.0001ZM20.5 17.0001H11.5C10.9478 17.0001 10.5 16.5523 10.5 16.0001C10.5 15.4478 10.9478 15.0001 11.5 15.0001H20.5C21.0522 15.0001 21.5 15.4478 21.5 16.0001C21.5 16.5523 21.0522 17.0001 20.5 17.0001Z"
                          fill="#06AB9F"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_2855_12228">
                          <rect width="32" height="32" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  {/* <div className="flex justify-start items-center bg-[#EEF9F8] gap-96 w-full h-11 -m-1"> */}
                  <div className="flex bg-[#EEF9F8] w-full lg:py-3 relative lg:-left-2 -left-3 items-center lg:pl-5 lg:pr-10 px-3 py-2 justify-between">
                    <p className=" font-medium lg:text-sm text-[10px] text-[#222222]">
                      “Join our newsletter to receive the latest news”
                    </p>
                    <Link
                      to="#"
                      onClick={handleSubscribeClick}
                      className="border border-[#06AB9F] text-[#06AB9F] text-center  font-medium md:text-sm text-[10px] py-[5px] md:px-2 px-1"
                    >
                      Subscribe Now
                    </Link>
                  </div>
                  {/* </div> */}
                </div>
              )}

              <div className="lg:block hidden">
                {cart_items_numberResponseSuccess_info?.length > 0 &&
                  userProfile_id ? (
                  <div className="border border-solid lg:px-6 px-4 rounded-3xl w-full">
                    {cart_items_numberResponseSuccess_info?.map(
                      (item, index) => (
                        <div className="border-b-2 last:border-b-0 pt-4 pb-4">
                          <div className="flex justify-between items-start mb-5 mt-5">
                            <div className="flex justify-start items-center gap-5">
                              <div
                                className="cursor-pointer"
                                onClick={() => {
                                  window.location.href = `${item?.transSkuListByProductSku?.skuUrl}`;
                                }}
                              >
                                <img
                                  src={getImage(
                                    item?.transSkuListByProductSku
                                      ?.productListByProductId
                                      ?.productImagesByProductId.nodes[0]
                                      ?.imageUrl
                                  )}
                                  alt="ring"
                                  className="w-[200px] object-cover rounded-md"
                                />
                              </div>
                              <div>
                                <p
                                  className="font-medium text-[15px] text-mt-3 md:mt-0 text-[#222222]  cursor-pointer"
                                  onClick={() => {
                                    window.location.href = `${item?.transSkuListByProductSku?.skuUrl}`;
                                  }}
                                >
                                  {
                                    descriptionShow(item?.transSkuListByProductSku
                                      ?.productListByProductId?.productName)
                                  }
                                </p>
                                <p
                                  className="mb-5 font-medium text-[15px] mt-3 md:mt-0 text-[#222222]  cursor-pointer"
                                  onClick={() => {
                                    window.location.href = `${item?.transSkuListByProductSku?.skuUrl}`;
                                  }}
                                >
                                  {item?.productSku}
                                </p>
                                <div className="flex mb-5 justify-between items-center">
                                  <p className="font-bold text-sm text-customBlue pr-2">
                                    {formatCurrencywithamount(
                                      item?.price,
                                      (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                                      (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                                      dailyMetalPriceSuccess?.data
                                        ?.allMasterCountries?.nodes
                                    )}
                                  </p>
                                  {item?.transSkuListByProductSku
                                    ?.discountPrice !== 0 &&
                                    item?.transSkuListByProductSku
                                      ?.discountPrice !== "0" &&
                                    item?.price !==
                                    item?.transSkuListByProductSku
                                      ?.discountPrice && (
                                      <p className="text-sm font-medium line-through text-customBlue pr-2">
                                        {formatCurrencywithamount(
                                          item?.transSkuListByProductSku
                                            ?.discountPrice,
                                          (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                                          (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                                          dailyMetalPriceSuccess?.data
                                            ?.allMasterCountries?.nodes
                                        )}
                                      </p>
                                    )}

                                  {item?.transSkuListByProductSku?.discount >
                                    0 && (
                                      <p className="text-customBlue font-medium text-sm pr-5">
                                        (
                                        {item?.transSkuListByProductSku
                                          ?.discount || 0}
                                        % - OFF)
                                      </p>
                                    )}
                                  <Link
                                    to="#"
                                    className="underline text-customLightGreen text-sm font-normal tracking-wider"
                                    onClick={() =>
                                      handleRemoveItem(item?.productSku)
                                    }
                                  >
                                    Remove
                                  </Link>
                                </div>
                                <div>
                                  {userProfile_id ? (
                                    <Link
                                      to="#"
                                      className="border border-[#DFDFDF] px-10 py-3 mt-2 text-[#222222] text-sm font-normal  hover:border-customLightGreen hover:text-customLightGreen"
                                      onClick={() =>
                                        handleAddToWishlist(
                                          item?.productSku,
                                          item?.transSkuListByProductSku
                                            ?.productListByProductId?.productId
                                        )
                                      }
                                    >
                                      Move to wishlist
                                    </Link>
                                  ) : (
                                    <Link
                                      to="#"
                                      className="border border-[#DFDFDF] px-10 py-3 mt-2 text-[#222222] text-sm font-normal  hover:border-customLightGreen hover:text-customLightGreen"
                                      onClick={() =>
                                        handleAddToWishlist(
                                          item?.productSku,
                                          item?.transSkuListByProductSku
                                            ?.productListByProductId?.productId
                                        )
                                      }
                                    >
                                      Move to wishlist
                                    </Link>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="justify-self-center pr-10 flex flex-col items-end">
                              <p className="text-[#595959]  text-sm font-normal mt-5 md:mt-8">
                                Quantity : {item?.qty}
                              </p>
                              {item?.transSkuListByProductSku?.skuSize && <p className="text-[#595959]  text-sm font-normal  ">
                                Size : {item?.transSkuListByProductSku?.skuSize}"
                              </p>}
                            </div>
                          </div>
                          {/* <hr className="border-t-1 border-gray-300 my-6 rounded-lg" /> */}
                        </div>
                      )
                    )}
                  </div>
                ) : (
                  //without login
                  <div className="border border-solid lg:px-6 px-4 rounded-3xl gap-4 w-full">
                    {cartDetails?.products?.map((item, index) => (
                      <div className="border-b-2 last:border-b-0 pt-4 pb-4">
                        <div className="flex justify-between items-start mb-5 mt-5">
                          <div className="flex justify-start items-center gap-5">
                            <div
                              className="cursor-pointer"
                              onClick={() => {
                                window.location.href = `${item?.skuUrl}`;
                              }}
                            >
                              <img
                                src={item?.imageurl}
                                alt="ring"
                                className="w-[200px] object-cover rounded-md"
                              />
                            </div>
                            <div>
                              <p
                                className="font-medium text-[15px] text-mt-3 md:mt-0 text-[#222222] cursor-pointer"
                                onClick={() => {
                                  window.location.href = `${item?.skuUrl}`;
                                }}
                              >
                                {item?.productname}
                              </p>
                              <p
                                className="mb-5 font-medium text-sm mt-3 md:mt-0 text-[#222222] cursor-pointer"
                                onClick={() => {
                                  window.location.href = `${item?.skuUrl}`;
                                }}
                              >
                                {item?.sku_id}
                              </p>
                              <div className="flex mb-5 justify-between items-center">
                                <p className="font-semibold text-lg text-customBlue pr-2">
                                  {formatCurrencywithamount(
                                    item?.price,
                                    (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                                    (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                                    dailyMetalPriceSuccess?.data
                                      ?.allMasterCountries?.nodes
                                  )}
                                </p>
                                {item?.price !== item?.discountprice && (
                                  <>
                                    <p className="text-sm font-medium line-through text-customBlue pr-2">
                                      {formatCurrencywithamount(
                                        item?.discountprice,
                                        (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                                        (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                                        dailyMetalPriceSuccess?.data
                                          ?.allMasterCountries?.nodes
                                      )}
                                    </p>
                                    <p className="text-customBlue font-medium text-sm pr-5">
                                      ({item?.discount || 0}% - OFF)
                                    </p>
                                  </>
                                )}
                                <Link
                                  to="#"
                                  className="underline text-customLightGreen text-sm font-medium tracking-wider"
                                  onClick={() => handleRemoveItem(item?.sku_id)}
                                >
                                  Remove
                                </Link>
                              </div>
                              <div>
                                {
                                  userProfile_id && (
                                    <Link
                                      to="#"
                                      className="border border-[#DFDFDF] px-10 py-3 mt-2 text-[#222222] text-sm font-normal  hover:border-customLightGreen hover:text-customLightGreen"
                                    >
                                      Move to wishlist
                                    </Link>
                                  )
                                  // : (
                                  //   <Link
                                  //     to="#"
                                  //     className="border border-[#DFDFDF] px-10 py-3 mt-2 text-[#222222] text-sm font-normal  hover:border-customLightGreen hover:text-customLightGreen"
                                  //   >
                                  //     Move to wishlist
                                  //   </Link>
                                  // )
                                }
                              </div>
                            </div>
                          </div>
                          <div className="justify-self-center flex flex-col items-end">
                            <p className="text-[#595959]  text-sm font-normal mt-5 md:mt-10">
                              Quantity : {item?.qty}
                            </p>
                            {item?.size && <p className="text-[#595959]  text-sm font-normal ">
                              Size : {item?.size} "
                            </p>}
                          </div>
                        </div>
                        {/* <hr className="border-t-1 border-gray-300 my-6 rounded-lg" /> */}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {/* {cart_items_numberResponseSuccess_info.length === 0 && cartDetails?.products.length > 0 && <>without login case</>} */}

              {/* For Mobile cart */}
              <div className="lg:hidden block">
                {cart_items_numberResponseSuccess_info?.length > 0 &&
                  userProfile_id ? (
                  <div className="lg:px-6 px-4 rounded-3xl gap-4 w-full">
                    {cart_items_numberResponseSuccess_info?.map(
                      (item, index) => (
                        <div className="pt-4 pb-4">
                          <div className="flex justify-start items-center gap-5">
                            <div
                              className="cursor-pointer"
                              onClick={() => {
                                window.location.href = `${item?.transSkuListByProductSku?.skuUrl}`;
                              }}
                            >
                              <img
                                src={getImage(
                                  item?.transSkuListByProductSku
                                    ?.productListByProductId
                                    ?.productImagesByProductId.nodes[0]
                                    ?.imageUrl
                                )}
                                // src={constants.DEFAULT_IMAGE + "/varshin.jpg"}
                                alt="ring"
                                className="rounded "
                              />
                            </div>
                            <div className=" w-full">
                              <p
                                className="font-medium  text-sm text-mt-3 md:mt-0 text-[#222222]  cursor-pointer"
                                onClick={() => {
                                  window.location.href = `${item?.transSkuListByProductSku?.skuUrl}`;
                                }}
                              >
                                {
                                  descriptionShow(item?.transSkuListByProductSku
                                    ?.productListByProductId?.productName)
                                }
                              </p>
                              <p
                                className="mb-3 font-medium text-sm mt-3 md:mt-0 text-[#222222]  cursor-pointer"
                                onClick={() => {
                                  window.location.href = `${item?.transSkuListByProductSku?.skuUrl}`;
                                }}
                              >
                                {item?.productSku}
                              </p>
                              {item?.transSkuListByProductSku?.skuSize && <p
                                className="mb-3 font-medium text-sm mt-3 md:mt-0 text-[#222222]  cursor-pointer"
                                onClick={() => {
                                  window.location.href = `${item?.transSkuListByProductSku?.skuUrl}`;
                                }}
                              >
                                Size : {item?.transSkuListByProductSku?.skuSize} "
                              </p>}
                              <div className="flex mb-1 justify-between items-center">
                                <p className="font-bold text-sm text-customBlue pr-2">
                                  {formatCurrencywithamount(
                                    item?.price,
                                    (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                                    (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                                    dailyMetalPriceSuccess?.data
                                      ?.allMasterCountries?.nodes
                                  )}
                                </p>
                                {item?.transSkuListByProductSku
                                  ?.discountPrice !== 0 &&
                                  item?.transSkuListByProductSku
                                    ?.discountPrice !== "0" &&
                                  item?.price !==
                                  item?.transSkuListByProductSku
                                    ?.discountPrice && (
                                    <p className="text-sm font-medium line-through text-customBlue pr-2">
                                      {formatCurrencywithamount(
                                        item?.transSkuListByProductSku
                                          ?.discountPrice,
                                        (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                                        (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                                        dailyMetalPriceSuccess?.data
                                          ?.allMasterCountries?.nodes
                                      )}
                                    </p>
                                  )}

                                {item?.transSkuListByProductSku?.discount >
                                  0 && (
                                    <p className="text-customBlue font-medium text-sm pr-5">
                                      (
                                      {item?.transSkuListByProductSku?.discount ||
                                        0}
                                      % - OFF)
                                    </p>
                                  )}
                              </div>
                              <div className="flex justify-between items-center gap-0">
                                {userProfile_id ? (
                                  <Link
                                    to="#"
                                    className="border border-[#DFDFDF] px-3 py-2 text-[#222222] text-sm font-normal  hover:border-customLightGreen hover:text-customLightGreen"
                                    onClick={() =>
                                      handleAddToWishlist(
                                        item?.productSku,
                                        item?.transSkuListByProductSku
                                          ?.productListByProductId?.productId
                                      )
                                    }
                                  >
                                    Move to wishlist
                                  </Link>
                                ) : (
                                  <Link
                                    to="#"
                                    className="border border-[#DFDFDF] px-10 py-3 text-[#222222] text-sm font-normal  hover:border-customLightGreen hover:text-customLightGreen"
                                    onClick={() =>
                                      handleAddToWishlist(
                                        item?.productSku,
                                        item?.transSkuListByProductSku
                                          ?.productListByProductId?.productId
                                      )
                                    }
                                  >
                                    Move to wishlist
                                  </Link>
                                )}

                                <Link
                                  to="#"
                                  className="underline text-customLightGreen text-sm font-normal tracking-wider"
                                  onClick={() =>
                                    handleRemoveItem(item?.productSku)
                                  }
                                >
                                  Remove
                                </Link>
                              </div>
                            </div>
                          </div>
                          <div className="pr-10">
                            <p className="text-[#595959] text-sm font-normal mt-5 md:mt-10">
                              Quantity : {item?.qty}
                            </p>
                          </div>
                          {/* <hr className="border-t-1 border-gray-300 my-6 rounded-lg" /> */}
                        </div>
                      )
                    )}
                  </div>
                ) : (
                  <div className="px-6 rounded-3xl gap-4 w-full">
                    {cartDetails?.products?.map((item, index) => (
                      <div className="pt-8 pb-8">
                        <div className="mb-5 mt-5">
                          <div className="flex justify-start items-center gap-5">
                            <div
                              className="cursor-pointer"
                              onClick={() => {
                                window.location.href = `${item?.skuUrl}`;
                              }}
                            >
                              <img
                                src={item?.imageurl}
                                alt="ring"
                                className="w-8/12 object-cover rounded-sm"
                              />
                            </div>
                            <div>
                              <p
                                className="font-medium text-[15px]] text-mt-3 md:mt-0 text-[#222222] cursor-pointer"
                                onClick={() => {
                                  window.location.href = `${item?.skuUrl}`;
                                }}
                              >
                                {descriptionShow(item?.productname)}
                              </p>
                              {item?.size && <p
                                className="font-medium text-[15px]] text-mt-3 md:mt-0 text-[#222222] cursor-pointer"
                                
                              >
                                Size : {item?.size}"
                              </p>}
                              <p
                                className="mb-5 font-semibold text-sm mt-3 md:mt-0 text-[#222222] cursor-pointer"
                                onClick={() => {
                                  window.location.href = `${item?.skuUrl}`;
                                }}
                              >
                                {item?.sku_id}
                              </p>
                              <div className="flex mb-5 justify-between items-center">
                                <p className="font-semibold text-lg text-customBlue pr-2">
                                  {formatCurrencywithamount(
                                    item?.price,
                                    (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                                    (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                                    dailyMetalPriceSuccess?.data
                                      ?.allMasterCountries?.nodes
                                  )}
                                </p>
                                {item?.price !== item?.discountprice ?? (
                                  <>
                                    <p className="text-sm font-medium line-through text-customBlue pr-2">
                                      {formatCurrencywithamount(
                                        item?.discountprice,
                                        (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                                        (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                                        dailyMetalPriceSuccess?.data
                                          ?.allMasterCountries?.nodes
                                      )}
                                    </p>
                                    <p className="text-customBlue font-medium text-sm pr-5">
                                      ({item?.discount || 0}% - OFF)
                                    </p>
                                  </>
                                )}
                                <Link
                                  to="#"
                                  className="underline text-customLightGreen text-sm font-medium tracking-wider"
                                  onClick={() => handleRemoveItem(item?.sku_id)}
                                >
                                  Remove
                                </Link>
                              </div>
                              <div>
                                {
                                  userProfile_id && (
                                    <Link
                                      to="#"
                                      className="border border-[#DFDFDF] px-10 py-3 mt-2 text-[#222222] text-sm font-normal  hover:border-customLightGreen hover:text-customLightGreen"
                                    >
                                      Move to wishlist
                                    </Link>
                                  )
                                  // : (
                                  //   <Link
                                  //     to="#"
                                  //     className="border border-[#DFDFDF] px-10 py-3 mt-2 text-[#222222] text-sm font-normal  hover:border-customLightGreen hover:text-customLightGreen"
                                  //   >
                                  //     Move to wishlist
                                  //   </Link>
                                  // )
                                }
                              </div>
                            </div>
                          </div>
                          <div className="justify-self-center">
                            <p className="text-[#595959]  text-sm font-normal mt-5 md:mt-10">
                              Quantity : {item?.qty}
                            </p>
                          </div>
                        </div>
                        {/* <hr className="border-t-1 border-gray-300 my-6 rounded-lg" /> */}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="lg:grid lg:grid-cols-12 gap-6 mt-16 hidden">
                <div className="col-span-12 lg:col-span-3">
                  <div className="border border-solid p-5 rounded-tr-[30px] rounded-bl-[30px] relative">
                    <div className="absolute end-5 top-[-20px]">
                      <img
                        alt="Certified 925 Silver"
                        src={constants.DEFAULT_IMAGE + "/stylori_purity.svg"}
                        className="!w-[50px] !h-[50px]"
                      />
                    </div>
                    <p className="text-lg font-bold text-gradient mb-2 font-tiemann">
                      Certified 925 Silver
                    </p>
                    <p className="text-[14px] font-light text-[#222222]">
                      Crafted with certified 925 sterling silver for lasting shine.
                    </p>
                  </div>
                </div>
                <div className="col-span-12 lg:col-span-3">
                  <div className="border border-solid p-5 rounded-tr-[30px] rounded-bl-[30px] relative">
                    <div className="absolute end-5 top-[-20px]">
                      <img
                        alt="Free Shipping"
                        src={constants.DEFAULT_IMAGE + "/stylori_shipping.svg"}
                        className="!w-[50px] !h-[50px]"
                      />
                    </div>
                    <p className="text-lg font-bold text-gradient mb-2 font-tiemann">
                      Free Shipping
                    </p>
                    <p className="text-[14px] font-light text-[#222222]">
                      Pan-India free shipping on all orders.
                    </p>
                  </div>
                </div>
                <div className="col-span-12 lg:col-span-3">
                  <div className="border border-solid p-5 rounded-tr-[30px] rounded-bl-[30px] relative">
                    <div className="absolute end-5 top-[-20px]">
                      <img
                        alt="100 year of trust"
                        src={constants.DEFAULT_IMAGE + "/stylori_since.svg"}
                        className="!w-[50px] !h-[50px]"
                      />
                    </div>
                    <p className="text-lg font-bold text-gradient mb-2 font-tiemann">
                      100 year of trust
                    </p>
                    <p className="text-[14px] font-light text-[#222222]">
                      Born from the house of NAC, made just for you.
                    </p>
                  </div>
                </div>
                <div className="col-span-12 lg:col-span-3">
                  <div className="border border-solid p-5 rounded-tr-[30px] rounded-bl-[30px] relative">
                    <div className="absolute end-5 top-[-20px]">
                      <img
                        alt="Hypoallergenic"
                        src={constants.DEFAULT_IMAGE + "/stylori_covid.svg"}
                        className="!w-[50px] !h-[50px]"
                      />
                    </div>
                    <p className="text-lg font-bold text-gradient mb-2 font-tiemann">
                      Hypoallergenic
                    </p>
                    <p className="text-[14px] font-light text-[#222222]">
                      Gentle on skin, Hypoallergenic by design.
                    </p>
                  </div>
                </div>
              </div>


              {/* Mobile Jewellery Quality */}

              <div className="lg:hidden mt-0 mb-0 lg:px-5 px-0 py-3">
                <Swiper
                  slidesPerView={1}
                  grid={{
                    rows: 1,
                  }}
                  spaceBetween={15}
                  pagination={{
                    clickable: true,
                  }}
                  autoplay={{ delay: 5000, disableOnInteraction: false }}
                  modules={[Grid, Pagination, Autoplay]}
                  className="mySwiper swipper-jewel"
                  onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
                >
                  <>
                    <SwiperSlide>
                      <div
                        className={`border border-[#D2D2D2] p-5 rounded-tr-[30px] rounded-bl-[30px] !w-[320px] !h-[125px] relative ${activeIndex === 0 ? "!overflow-visible" : "hidden"
                          }`}>
                        <div className="absolute end-5 -top-6 right-10">
                          <img
                            alt="Certified 925 Silver"
                            src={constants.DEFAULT_IMAGE + "/stylori_purity.svg"}
                            className="!w-[50px] !h-[50px] object-cover"
                          />
                        </div>
                        <p className="text-xl font-bold text-gradient mb-2 font-tiemann text-left">
                          Certified 925 Silver
                        </p>
                        <p className="text-base font-light font-century text-left">
                          Crafted with certified 925 sterling silver for lasting shine.
                        </p>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide className="flex-col relative">
                      <div className={`border border-[#D2D2D2] p-5 rounded-tr-[30px] rounded-bl-[30px] !w-[320px] !h-[125px] relative ${activeIndex === 1 ? "!overflow-visible z-10" : "hidden z-0"
                        }`}>
                        <div className="absolute end-5 -top-6 right-10 ">
                          {/* <img
                            alt="Certified img"
                            src="./images/Certified.svg"
                            className="!w-[52px] !h-[52px] object-cover z-50"
                          /> */}
                          <img
                            alt="Free Shipping"
                            src={constants.DEFAULT_IMAGE + "/stylori_shipping.svg"}
                            className="!w-[50px] !h-[50px] object-cover"
                          />
                        </div>
                        <p className="text-xl font-bold text-gradient mb-2 font-tiemann text-left">
                          Free Shipping
                        </p>
                        <p className="text-base font-light font-century text-left">
                          Pan-India free shipping on all orders.
                        </p>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide className="flex-col relative">
                      <div className={`border border-[#D2D2D2] p-5 rounded-tr-[30px] rounded-bl-[30px] !w-[320px] !h-[125px] relative ${activeIndex === 2 ? "!overflow-visible z-10" : "hidden z-0"
                        }`}>
                        <div className="absolute end-5 -top-6 right-10">
                          <img
                            alt="100 year of trust"
                            src={constants.DEFAULT_IMAGE + "/stylori_since.svg"}
                            className="!w-[50px] !h-[50px] object-cover"
                          />
                        </div>
                        <p className="text-xl font-bold text-gradient mb-2 font-tiemann text-left">
                          100 year of trust
                        </p>
                        <p className="text-base font-light font-century text-left">
                          Born from the house of NAC, made just for you.
                        </p>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide className="flex-col relative">
                      <div className={`border border-[#D2D2D2] p-5 rounded-tr-[30px] rounded-bl-[30px] !w-[320px] !h-[125px] relative ${activeIndex === 3 ? "!overflow-visible z-10" : "hidden z-0"
                        }`}>
                        <div className="absolute end-5 -top-6 right-10">
                          <img
                            alt="Hypoallergenic"
                            src={constants.DEFAULT_IMAGE + "/stylori_covid.svg"}
                            className="!w-[50px] !h-[50px] object-cover"
                          />
                        </div>
                        <p className="text-xl font-bold text-gradient mb-2 font-tiemann text-left">
                          Hypoallergenic
                        </p>
                        <p className="text-base font-light text-left">
                          Gentle on skin, Hypoallergenic by design.
                        </p>
                      </div>
                    </SwiperSlide>
                  </>
                </Swiper>
              </div>


            </div>
            <div className="col-span-12 lg:col-span-4">
              <div
                className={`w-full px-4 py-2 font-bold text-lg transition-all duration-300 ${isOpen
                  ? "border border-[#06AB9F] bg-white text-[#06AB9F]"
                  : "bg-[#06AB9F] text-white"
                  }`}
              >
                <div className="relative w-full flex justify-between items-center">
                  <div className="flex items-center gap-3">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="fill-current transition-transform duration-100"
                    >
                      <path d="M22.3594 6.49163H14.0096C14.2809 6.04758 14.4375 5.52614 14.4375 4.9688C14.4375 3.35339 13.1232 2.03911 11.5078 2.03911C10.5042 2.03911 9.58561 2.5417 9.04308 3.38545L7.21875 5.74336L5.39442 3.38545C4.85194 2.5417 3.93338 2.03906 2.92969 2.03906C1.31428 2.03906 0 3.35334 0 4.96875C0 5.66948 0.247594 6.31336 0.659484 6.81806C0.259406 7.11755 0 7.59516 0 8.13225V20.3198C0 21.2244 0.735984 21.9604 1.64062 21.9604H22.3594C23.264 21.9604 24 21.2244 24 20.3198V8.13225C24 7.22756 23.264 6.49163 22.3594 6.49163ZM22.5938 20.3198C22.5938 20.449 22.4886 20.5541 22.3594 20.5541H7.92188V8.96569L9.34223 10.9358C9.47967 11.1265 9.69483 11.2278 9.91317 11.2278C10.0556 11.2278 10.1994 11.1847 10.3238 11.095C10.6388 10.8679 10.71 10.4285 10.4829 10.1135L8.88586 7.8983L22.3594 7.89788C22.4886 7.89788 22.5938 8.00302 22.5938 8.13225V20.3198ZM2.92969 3.44531C3.45802 3.44531 3.94116 3.71353 4.22217 4.16273C4.23455 4.18252 4.24791 4.20169 4.26216 4.22011L6.01997 6.492L2.95355 6.49158C2.95148 6.49158 2.94942 6.49158 2.94736 6.49158C2.93925 6.49163 2.93114 6.49186 2.92219 6.49214C2.08561 6.48811 1.40625 5.80631 1.40625 4.96875C1.40625 4.12875 2.08969 3.44531 2.92969 3.44531ZM10.2153 4.16273C10.4963 3.71353 10.9795 3.44531 11.5078 3.44531C12.3478 3.44531 13.0312 4.12875 13.0312 4.96875C13.0312 5.80636 12.3518 6.4883 11.5151 6.49219C11.5074 6.49195 11.4998 6.49177 11.4922 6.49167C11.4894 6.49167 11.4867 6.49163 11.484 6.49163L8.41753 6.49205L10.1753 4.22011C10.1896 4.20164 10.203 4.18252 10.2153 4.16273ZM1.40625 20.3198V8.13225C1.40625 8.00302 1.51139 7.89788 1.64062 7.89788L5.60967 7.89825L4.2195 9.93488C4.00059 10.2556 4.08309 10.6931 4.40386 10.912C4.72462 11.1309 5.16206 11.0484 5.38102 10.7277L6.51562 9.06539V20.5541H1.64062C1.51139 20.5541 1.40625 20.4489 1.40625 20.3198Z" />
                      <path d="M12.9375 12.1172H16.4531C16.8414 12.1172 17.1562 11.8024 17.1562 11.4141C17.1562 11.0257 16.8414 10.7109 16.4531 10.7109H12.9375C12.5492 10.7109 12.2344 11.0257 12.2344 11.4141C12.2344 11.8024 12.5492 12.1172 12.9375 12.1172Z" />
                      <path d="M19.2656 13.5234H12.9375C12.5492 13.5234 12.2344 13.8382 12.2344 14.2266C12.2344 14.6149 12.5492 14.9297 12.9375 14.9297H19.2656C19.6539 14.9297 19.9688 14.6149 19.9688 14.2266C19.9688 13.8382 19.6539 13.5234 19.2656 13.5234Z" />
                      <path d="M19.2656 16.3359H12.9375C12.5492 16.3359 12.2344 16.6507 12.2344 17.0391C12.2344 17.4274 12.5492 17.7422 12.9375 17.7422H19.2656C19.6539 17.7422 19.9688 17.4274 19.9688 17.0391C19.9688 16.6507 19.6539 16.3359 19.2656 16.3359Z" />
                    </svg>
                    <p className=" font-medium text-sm">
                      Apply Coupon
                    </p>
                  </div>
                  <button
                    onClick={() => setIsOpen(!isOpen)}
                    className="p-2 transition-transform duration-300 flex justify-between items-center"
                  >
                    <svg
                      width="17"
                      height="18"
                      viewBox="0 0 17 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className={`fill-current transition-transform duration-100 ${isOpen ? "rotate-180" : ""
                        }`}
                    >
                      <path d="M14.3154 6.87727L13.3665 5.86865L8.49964 11.0419L3.63274 5.86865L2.68385 6.87726L8.49964 13.0265L14.3154 6.87727Z" />
                    </svg>
                  </button>
                </div>
                {isOpen && (
                  <div className="mt-2 flex items-center relative">
                    <input
                      type="text"
                      placeholder="Enter Promo Code"
                      className="w-full p-4 border text-[#787878] border-[#F0F0F0]  font-normal text-sm focus:outline-none"
                      value={promoCode}
                      onChange={(e) => setPromoCode(e.target.value)}
                    />
                    <button
                      className="bg-[#06AB9F] text-white text-sm  font-normal absolute right-0 py-4 px-7"
                      onClick={handleApplyClick}
                    >
                      Apply

                    </button>
                  </div>
                )}
              </div>

              <div className="px-4 py-4 border border-solid mt-5 pb-10">
                <p className="font-medium text-lg mb-8 mt-5 text-[#222222] ">
                  Order Summary
                </p>
                <div className="flex justify-between">
                  <div>
                    <p className="mb-5 font-normal text-sm  text-[#222222]">
                      Subtotal
                    </p>
                    <p className="text-[#27BA4F] mb-5 font-normal  text-sm">
                      You Saved
                    </p>
                    {cart_items_numberResponseSuccess?.nodes[0]?.voucherCode && <p className="mb-5 font-normal text-sm  text-[#222222]">
                      {cart_items_numberResponseSuccess?.nodes[0]?.voucherDescription}
                    </p>}
                    <p className="mb-5  text-sm text-[#222222] font-normal">
                      Delivery charges
                    </p>
                    <p className="mb-5 font-semibold text-lg  text-[#222222]">
                      TOTAL COST
                    </p>
                  </div>
                  {cart_items_numberResponseSuccess?.nodes[0]?.voucherCode === null &&
                    cart_items_numberResponseSuccess_info?.length > 0 &&
                    userProfile_id ? (
                    <div className="text-right">
                      <p className="mb-5 text-sm  font-normal text-[#222222]">
                        {(discountprice_ordersummary !=
                          discountedPrice) && (
                            <>
                              <span className="line-through">
                                {formatCurrencywithamount(
                                  discountprice_ordersummary,
                                  (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                                  (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                                  dailyMetalPriceSuccess?.data?.allMasterCountries
                                    ?.nodes
                                )}</span>{" "}
                            </>
                          )}
                        {formatCurrencywithamount(
                          discountedPrice,
                          (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                          (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                          dailyMetalPriceSuccess?.data?.allMasterCountries
                            ?.nodes
                        )}
                      </p>
                      <p className="text-[#27BA4F] mb-5 font-normal text-sm ">
                        -{" "}
                        {formatCurrencywithamount(
                          (discountprice_ordersummary - cart_items_numberResponseSuccess?.nodes[0]?.netAmount),
                          (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                          (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                          dailyMetalPriceSuccess?.data?.allMasterCountries
                            ?.nodes
                        )}
                      </p>
                      <p className="mb-5  font-normal text-[#222222] text-sm">
                        {formatCurrencywithamount(
                          cart_items_numberResponseSuccess?.nodes[0]
                            ?.shippingCharge,
                          (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                          (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                          dailyMetalPriceSuccess?.data?.allMasterCountries
                            ?.nodes
                        )}
                      </p>
                      <p className="mb-5 font-semibold text-sm  text-[#222222]">
                        {formatCurrencywithamount(
                          discountedPrice,
                          (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                          (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                          dailyMetalPriceSuccess?.data?.allMasterCountries
                            ?.nodes
                        )}
                      </p>
                    </div>
                  ) : cart_items_numberResponseSuccess?.nodes[0]?.voucherCode === null ? (
                    // without login
                    <div className="text-right">
                      <p className="mb-5 text-sm  font-normal text-[#222222] "><span className="line-through">
                        {netPrice_without_login !== actualPrice_without_login && formatCurrencywithamount(
                          netPrice_without_login,
                          (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                          (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                          dailyMetalPriceSuccess?.data?.allMasterCountries
                            ?.nodes
                        )}</span>
                        {" "}
                        {
                          formatCurrencywithamount(
                            actualPrice_without_login,
                            (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                            (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                            dailyMetalPriceSuccess?.data?.allMasterCountries
                              ?.nodes
                          )}

                      </p>
                      <p className="text-[#27BA4F] mb-5 font-normal text-sm ">
                        -{" "}
                        {formatCurrencywithamount(
                          netPrice_without_login - actualPrice_without_login,
                          (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                          (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                          dailyMetalPriceSuccess?.data?.allMasterCountries
                            ?.nodes
                        )}
                      </p>
                      <p className="mb-5  font-normal text-[#222222] text-sm">
                        {formatCurrencywithamount(
                          0,
                          (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                          (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                          dailyMetalPriceSuccess?.data?.allMasterCountries
                            ?.nodes
                        )}
                      </p>
                      <p className="mb-5 font-semibold text-sm  text-[#222222]">
                        {formatCurrencywithamount(
                          actualPrice_without_login,
                          (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                          (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                          dailyMetalPriceSuccess?.data?.allMasterCountries
                            ?.nodes
                        )}
                      </p>
                    </div>
                  ) : (
                    //voucher applied
                    <div className="text-right">
                      <div className="flex   w-full mb-5 ">


                        {discountprice_ordersummary !== markupprice_ordersummary && (
                          <p className=" pe-2  text-sm font-normal text-[#222222] line-through">
                            {formatCurrencywithamount(
                              discountprice_ordersummary,
                              selectedcountrySuccess?.currencyAlias || '',
                              selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess.iso}` : '',
                              dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
                            )}{" "}
                          </p>
                        )}
                        <p className="text-sm font-normal text-[#222222] pl-2">{formatCurrencywithamount(
                          cart_items_numberResponseSuccess?.nodes[0]?.netAmount,
                          (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                          (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                          dailyMetalPriceSuccess?.data?.allMasterCountries
                            ?.nodes
                        )}
                        </p>
                      </div>
                      <p className="text-[#27BA4F] mb-5 font-normal text-sm ">
                        -{" "}
                        {formatCurrencywithamount(
                          (discountprice_ordersummary - cart_items_numberResponseSuccess?.nodes[0]?.netAmount),
                          (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                          (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                          dailyMetalPriceSuccess?.data?.allMasterCountries
                            ?.nodes
                        )}
                      </p>
                      {cart_items_numberResponseSuccess?.nodes[0]?.voucherCode && <p className="mb-5  font-normal text-[#222222] text-sm">
                        {formatCurrencywithamount(
                          parseFloat(cart_items_numberResponseSuccess?.nodes[0]?.discount),
                          (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                          (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                          dailyMetalPriceSuccess?.data?.allMasterCountries
                            ?.nodes
                        )}
                      </p>}
                      <p className="mb-5  font-normal text-[#222222] text-sm">
                        {formatCurrencywithamount(
                          cart_items_numberResponseSuccess?.nodes[0]?.shippingCharge,
                          (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                          (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                          dailyMetalPriceSuccess?.data?.allMasterCountries
                            ?.nodes
                        )}
                      </p>
                      <p className="mb-5 font-semibold text-sm  text-[#222222]">
                        {formatCurrencywithamount(
                          cart_items_numberResponseSuccess?.nodes[0]?.discountedPrice,
                          (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                          (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                          dailyMetalPriceSuccess?.data?.allMasterCountries
                            ?.nodes
                        )}
                      </p>
                    </div>
                  )}
                </div>
                <p className="font-normal text-[#858585] text-sm">
                  International shipping charges will be calculated at the
                  checkout page Checkout Securely
                </p>
              </div>
            </div>
          </div>
          <div className="lg:grid lg:grid-cols-1 gap-6 hidden">
            <div className="col-span-12 lg:col-span-12">
              <p className="text-[28px] font-normal mt-10 text-black">
                You may also like
              </p>
              <p className="text-sm  font-normal text-[#757575] mt-3">
                Explore our curated collection of stunning silver pieces that
                complement your style
              </p>
            </div>

            <Swiper
              slidesPerView={4}
              grid={{
                rows: 1,
              }}
              spaceBetween={20}

              loop={true} // Enable loop
              autoplay={{
                delay: 2500, // Adjust the delay time as needed
                disableOnInteraction: false, // Set to true if you want to stop autoplay on user interaction
              }}
              modules={[Grid, Autoplay]} // Add the Autoplay module
              className="mySwiper"
            >
              {/* has to be changed */}

              {youMayLike_responseSuccess &&
                youMayLike?.map((like, i) => {
                  return (
                    <SwiperSlide className="">
                      <div key={i} className="lg:col-span-3 md:col-span-6">
                        <Link
                          to={like?.transSkuListsByProductId?.nodes[0]?.skuUrl}
                        >
                          <img
                            src={getImage(
                              like?.productImagesByProductId?.nodes[0]
                                ?.imageUrl,
                              "500X500"
                            )}
                            alt="test"
                            className="rounded-md"
                          />
                        </Link>
                        <p className=" font-normal text-base text-black text-center mt-3">
                          {descriptionShow(like?.productName)}
                        </p>
                        <div className="flex items-center gap-2 justify-center">
                          <p className=" font-normal text-sm text-black text-center">
                            {formatCurrencywithamount(
                              like?.transSkuListsByProductId?.nodes[0]
                                ?.markupPrice,
                              (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                              (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                              dailyMetalPriceSuccess?.data?.allMasterCountries
                                ?.nodes
                            )}
                          </p>
                          {like?.transSkuListsByProductId?.nodes[0]?.markupPrice != like?.transSkuListsByProductId?.nodes[0]?.discountPrice && (
                            <p className="font-normal text-sm text-black text-center line-through">
                              {formatCurrencywithamount(
                                like?.transSkuListsByProductId?.nodes[0]?.discountPrice,
                                selectedcountrySuccess?.currencyAlias || '',
                                selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : '',
                                dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
                              )}
                            </p>
                          )}

                          <p className="font-normal text-sm text-black text-center ">
                            {discount_display_price(like?.transSkuListsByProductId?.nodes[0]?.discount)}
                            
                          </p>
                        </div>

                      </div>
                    </SwiperSlide>
                  );
                })}
            </Swiper>
          </div>

          {/* Mobile */}
          <div className="grid grid-cols-1 gap-6 lg:hidden">
            <div className="">
              <p className="text-[28px] font-normal mt-10 text-black ">
                You may also like
              </p>
              <p className="text-sm  font-normal text-[#757575] mt-3">
                Explore our curated collection of stunning silver pieces that
                complement your style
              </p>
            </div>

            <Swiper
              slidesPerView={2.5}
              grid={{
                rows: 1,
              }}
              spaceBetween={20}

              modules={[Grid]}
              className="mySwiper"
            >
              {/* has to be changed */}

              {youMayLike_responseSuccess &&
                youMayLike?.map((like, i) => {
                  return (
                    <SwiperSlide className="">
                      <div key={i} className="lg:col-span-3 md:col-span-6">
                        <Link
                          to={like?.transSkuListsByProductId?.nodes[0]?.skuUrl}
                        >
                          <img
                            src={getImage(
                              like?.productImagesByProductId?.nodes[0]
                                ?.imageUrl,
                              "500X500"
                            )}
                            alt="test"
                            className="rounded-md"
                          />
                        </Link>
                        <p className=" font-normal text-base text-black text-center mt-3">
                          {descriptionShowYouMayLike(like?.productName)}
                        </p>
                        <div className="">
                          <p className=" font-normal text-sm text-black text-center">
                            {formatCurrencywithamount(
                              like?.transSkuListsByProductId?.nodes[0]
                                ?.markupPrice,
                              (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                              (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                              dailyMetalPriceSuccess?.data?.allMasterCountries
                                ?.nodes
                            )}
                          </p>
                          {like?.transSkuListsByProductId?.nodes[0]?.markupPrice != like?.transSkuListsByProductId?.nodes[0]?.discountPrice && (
                            <p className="font-normal text-sm text-black text-center line-through">
                              {formatCurrencywithamount(
                                like?.transSkuListsByProductId?.nodes[0]?.discountPrice,
                                selectedcountrySuccess?.currencyAlias || '',
                                selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : '',
                                dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
                              )}
                            </p>
                          )}
                          <p className="font-normal text-sm text-black text-center ">
                            {discount_display_price(like?.transSkuListsByProductId?.nodes[0]?.discount)}

                          </p>
                        </div>
                        {/* <p className=" font-normal text-sm text-black text-center">
                          {formatCurrencywithamount(
                            like?.transSkuListsByProductId?.nodes[0]
                              ?.discountPrice,
                            (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                            (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                            dailyMetalPriceSuccess?.data?.allMasterCountries
                              ?.nodes
                          )}
                        </p> */}
                      </div>
                    </SwiperSlide>
                  );
                })}
            </Swiper>
          </div>
        </div>
        <div className="bg-white border border-slate-200 py-8 px-0 shadow-top-only mt-5 sticky bottom-0 w-full z-[1]">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12 lg:col-span-6 mx-auto ">
                <p className="text-xl font-medium  text-[#222222]">
                  Total (
                  {userProfile_id
                    ? cartItemsProductInfo?.length || 0
                    : cartDetails?.products?.length || 0}{" "}
                  Items) :{" "}
                  {cartItemsProductInfo?.length && userProfile_id ? (
                    <span>
                      {formatCurrencywithamount(
                        cart_items_numberResponseSuccess?.nodes[0]?.discountedPrice,
                        (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                        (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                        dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
                      )}
                    </span>
                  ) : (
                    <span>
                      {formatCurrencywithamount(
                        actualPrice_without_login,
                        (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                        (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                        dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
                      )}
                    </span>
                  )}
                </p>
              </div>
              <div className="col-span-12 lg:col-span-6 mx-auto">
                <Link
                  to="#"
                  onClick={handleProceedCheckout}
                  className="text-white text-base text-center py-4 shadow-md px-10 bg-customGreen border border-customLightGreen hover:bg-white hover:border-gray-500 hover:text-customLightGreen duration-300 w-[220px] z-10 "
                >
                  Proceed to Checkout
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <div className="flex flex-col items-center justify-center min-h-screen text-center space-y-4">
      {/* SVG Image */}
      <img
        src={constants.DEFAULT_IMAGE + "/no-cart.svg"}
        alt="Empty Cart"
        className="w-32 h-32"
      />

      {/* Cart Title */}
      <h1 className="text-2xl font-semibold tracking-wide">CART</h1>

      {/* Empty Cart Message */}
      <p className="text-gray-600">Your cart is currently empty.</p>

      {/* Continue Shopping Button */}
      <button
        onClick={() =>
          navigate(
            constants.ADDITIONAL_PATH +
            "/silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
          )
        }
        className="mt-4 px-6 py-2 border border-gray-400 text-black rounded-md hover:bg-gray-100 transition"
      >
        Continue Shopping
      </button>
    </div>
  );
}

export default Cart;
